import { Expose } from "class-transformer";
import { ProductCategories } from "src/constants/product-categories";

import { BaseModel } from "src/shared/models/base.model";
import { RequestStatus } from "src/containers/requests/types/request-status";

export class CrmRequest extends BaseModel {
    @Expose() businessLine: ProductCategories = ProductCategories.SALUD;
    @Expose() categoryId = -1;
    @Expose() categoryName = "";
    @Expose() categoryNameMep = "";
    @Expose() channel = "";
    @Expose() creationDate = "";
    @Expose() incidentId = "";
    @Expose() policyNumber = "";
    @Expose() product = "";
    @Expose() referenceNumber = "";
    @Expose() sla = "";
    @Expose() solutionDate = "";
    @Expose() status: RequestStatus = RequestStatus.PENDING;
}
